import { render, staticRenderFns } from "./ImageCollage.vue?vue&type=template&id=67190f8c&"
import script from "./ImageCollage.vue?vue&type=script&lang=ts&"
export * from "./ImageCollage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports